<template>
  <div class="flex items-center space-x-2 w-max">
    <label class="switch cursor-pointer h-[15px]" :for="id ?? '1'">
      <input
        :type="type"
        class="hidden"
        :name="name"
        :id="id ?? '1'"
        @change="changeEvent"
        :checked="checked ?? false"
      />
      <span class="slider round"></span>
    </label>
    <label :for="id ?? '1'" class="select-none cursor-pointer">
      {{ title }}
    </label>
  </div>
</template>
<script setup lang="ts">
defineProps<{
  title: string;
  name: string;
  type: 'radio' | 'checkbox';
  id: string;
  checked?: boolean;
}>();
const emit = defineEmits(['update:modelValue']);
const changeEvent = (e: Event) => {
  emit('update:modelValue', (e.target as HTMLInputElement).checked);
};
</script>
<style lang="scss" scoped>
.switch {
  position: relative;
  width: 40px;
  background-color: #ccc;
  border-radius: 30px;
  .slider {
    position: absolute;
    height: 20px;
    width: 20px;
    background-color: #535353;
    border-radius: 50%;
    transform: translatey(-50%);
    transition: 0.2s;
    top: 50%;
  }
  input {
    &:checked + .slider {
      @apply bg-primary;
      transform: translate(20px, -50%);
    }
  }
  &:has(input:checked) {
    @apply bg-primary bg-opacity-45;
  }
}
</style>
